<app-pagetitle title="Editar Categoria de Orçamento" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
@if (error || erro403) {
@if(erro403){
<app-no-access></app-no-access>
}@else{

<div class="col-12">
    <div class="alert alert-danger" role="alert">{{ error }}</div>
</div>
}
} @else {
<form class="mb-3" [formGroup]="categoryForm" (ngSubmit)="onSubmit()">
    <input type="hidden" formControlName="id" />
    <h4 class="card-title">Categoria</h4>
    <div class="card col-12 mb-4">
        <div class="card-body">
            <div class="row">
                <!-- Name and Email -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label class="form-label" for="nome">Nome da categoria</label>
                        <input type="text" class="form-control" formControlName="nome" [ngClass]="{
                            'is-invalid':
                            categoryForm.controls.nome.errors &&
                            categoryForm.get('nome')?.touched,
                          }" />
                        <div class="invalid-feedback"
                            *ngIf="categoryForm.get('nome')?.touched && categoryForm.get('nome')?.invalid">
                            O nome é obrigatório.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">

                        <label class="form-label" for="tipoDeCalculo">Tipo De Calculo</label>

                        <select class="form-select" id="tipoDeCalculo" formControlName="tipoDeCalculo" [ngClass]="{
                            'is-invalid':
                            categoryForm.controls.nome.errors &&
                            categoryForm.get('nome')?.touched,
                          }">
                            <option value="3">Calculo Por Metro Quadrado</option>
                            <option value="1">Calculo Por Valor Unitário</option>
                            <option value="2">Calculo Por Valor Unitário + Pessoa</option>
                        </select>

                        <div class="invalid-feedback" *ngIf="
                            categoryForm.controls.tipoDeCalculo.errors &&
                            categoryForm.get('tipoDeCalculo')?.touched">

                            O tipo de cálculo é obrigatório.
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-check form-switch form-switch-md mb-3" dir="ltr">
                        <input formControlName="apresentarEmOrcamento" type="checkbox" class="form-check-input"
                            id="apresentarEmOrcamento">
                        <label class="form-check-label" for="apresentarEmOrcamento">Apresentar em Proposta
                            Comercial</label>
                    </div>
                    <div class="mt-4" *ngIf="categoryForm.get('apresentarEmOrcamento')?.value">
                        <h5 class="font-size-14 mb-3"><i class="mdi mdi-arrow-right text-primary me-1"></i>Selecione a
                            forma de apresentação</h5>
                        <div class="form-check mb-3">
                            <input formControlName="tipoDeApresentacao" class="form-check-input" type="radio"
                                id="formRadios1" value="1"
                                [checked]="categoryForm.get('tipoDeApresentacao')?.value == '1'">
                            <label class="form-check-label" for="formRadios1">
                                Apresentação Detalhada
                            </label>
                        </div>
                        <div class="form-check">
                            <input formControlName="tipoDeApresentacao" class="form-check-input" type="radio"
                                id="formRadios2" value="2"
                                [checked]="categoryForm.get('tipoDeApresentacao')?.value == '2'">
                            <label class="form-check-label" for="formRadios2">
                                Apresentação Resumida
                            </label>
                        </div>

                    </div>
                </div>

            </div>
            <div class="row mt-2">

                <div class="col-xl-6">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title mb-0">Categoria de Calculo <span
                                    ngbTooltip="Existem calculos de totais separados por despesas de itens operacionais e para materias separadamente."
                                    class="badge rounded-pill bg-warning ms-1">Info</span></h4>

                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div>
                                        <div class="form-check mb-2">
                                            <input class="form-check-input" type="radio"
                                                [checked]="categoryForm.get('tipoDeDespesa')?.value == '1'"
                                                formControlName="tipoDeDespesa" id="formRadios2" value="1">
                                            <label class="form-check-label" for="formRadios2">
                                                Categoria para despesa de materiais
                                            </label>
                                        </div>
                                        <div class="form-check mb-3">
                                            <input class="form-check-input" type="radio"
                                                [checked]="categoryForm.get('tipoDeDespesa')?.value == '0'"
                                                formControlName="tipoDeDespesa" id="formRadios1" value="0">
                                            <label class="form-check-label" for="formRadios1">
                                                Categoria para despesas operacionais
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="d-flex">
        <button (click)="voltar()" type="button" class="btn btn-soft-link waves-effect">Voltar</button>
        <button class="btn btn-success w-md" type="submit">
            @if (loading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            } @else {
            Atualizar
            }
        </button>
    </div>
</form>

<ngb-alert [dismissible]="false" class="mt-4 mb-0" type="warning">
    <h4 class="alert-heading">Atenção!</h4>
    <p><strong>Apresentação Detalhada:</strong> Será apresentado a categoria e todos os itens detalhadamente.</p>
    <p><strong>Apresentação Resumida:</strong> Será apresentado a categoria e apenas a quantidade de tens contidos na
        categoria.</p>

</ngb-alert>
}